import { render, staticRenderFns } from "./ClTableColumns.vue?vue&type=template&id=574179dc&scoped=true&"
import script from "./ClTableColumns.vue?vue&type=script&lang=js&"
export * from "./ClTableColumns.vue?vue&type=script&lang=js&"
import style0 from "./ClTableColumns.vue?vue&type=style&index=0&id=574179dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574179dc",
  null
  
)

export default component.exports